import * as React from 'react';
import { translation, currencyFormatter } from 'easit--localization';


interface ITicketWinWithErrorsItem {
    prizePotentialMin: number;
    prizePotentialMax: number;
    numberOfMistakes: number;
}

export interface ITicketWinWithErrorsProps {
    items: ITicketWinWithErrorsItem[];
}
export const TicketWinWithErrors = (props: ITicketWinWithErrorsProps) => {
    return props.items && props.items.length
        ? <table className="w-100 tip-list ticket-bet-list">
            <thead>
                <tr>
                    <th className="text-center">{translation().bet_Errors}</th>
                    <th>{translation().bet_PossibleWinFrom}</th>
                    <th>{translation().bet_PossibleWinTo}</th>
                </tr>
            </thead>
            <tbody>
                {
                    props.items.map(item => <tr key={item.numberOfMistakes}>
                        <td className="text-center">{item.numberOfMistakes}</td>
                        <td>{currencyFormatter.format(item.prizePotentialMin)}</td>
                        <td>{currencyFormatter.format(item.prizePotentialMax)}</td>
                    </tr>)
                }
            </tbody>
        </table>
        : null
}
